module.exports = __webpack_public_path__ + "static/media/preferences-grey.ec12d69f.svg";